<template>
  <div
    class="d-flex pa-2 flex-column mt-12"
    :style="{
      'margin-bottom': '40px',
      width: '80%',
      'min-height': '550px',
      height: 'min-content',
    }"
  >
    <div v-if="loading" class="d-flex pa-5 flex-column">
      <v-progress-linear
        top
        v-if="loading"
        :active="loading"
        :indeterminate="loading"
        color="red lighten-2"
      />
    </div>
    <v-card
      v-if="!loading"
      class="d-flex pa-2 flex-column"
      :style="{ margin: '0px 20px 40px 20px' }"
      elevation="2"
    >
      <v-card class="mb-12" height="20px" :style="{ 'box-shadow': '0 0 black', 'margin-top': '20px' }">
        <div class="d-flex pa-5 flex-column align-center justify-center">
          <h3 class="mb-5">Detail Approval Insert Transaction On Us</h3>
        </div>
      </v-card>
      <div :style="{ padding: '20px 50px 20px 50px' }" v-if="!loading">

      <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> NMID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.nmid }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> MID </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mid_bank }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> RRN </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.rrn }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Metode </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.payment_channel }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> MPAN </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.mpan }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Date </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.trx_date }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Time </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.trx_time }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Trx Amount </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.amount }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Log Request Payment Credit </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7" class="text-body-2">
            {{ data == null ? '' : data.log_request }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Log Response Payment Credit </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7" class="text-body-2">
            {{ data == null ? '' : data.log_response }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Request By </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_request_by_name }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Request Date Time </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_request_date }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="10" sm="4" class="font-weight-bold"> Approval Status </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            {{ data == null ? '' : data.maintenance_status }}
          </v-col>
        </v-row>

        <!-- Remarks -->
        <v-row class="d-flex justify-center align-center mt-12">
          <v-col cols="10" sm="4" class="font-weight-bold"> Remarks </v-col>
          <v-col cols="2" sm="1"> : </v-col>
          <v-col cols="12" sm="7">
            <v-text-field
              v-model="remark"
              placeholder="Tulis deskripsi alasan approve/reject insert transaction On us"
              :error-messages="remarksError"
              @input="validateRemarks"
              required
              multiline
              rows="3"
            />
          </v-col>
        </v-row>

        <!-- Checkbox Confirmation -->
        <v-row>
          <v-card-text>
            <div class="d-flex align-start">
              <v-checkbox
                v-model="confirmationChecked"
                color="primary"
                @change="validateForm"
              />
              <span>{{ confirmationText }}</span>
            </div>
          </v-card-text>
        </v-row>

        <!-- Action Buttons -->
        <v-row class="d-flex justify-space-between mt-16 mb-8">
          <!-- Back Button -->
          <v-btn @click="goBack" color="secondary">
            <v-icon>mdi-arrow-left</v-icon>
            Kembali
          </v-btn>

          <!-- Approve and Reject Buttons -->
          <div class="d-flex" >
            <v-btn
              :disabled="!formValid"
              color="red"
              @click="rejectAction"
              class="mr-4"
              style="color: #fff;"
              :loading="loading"
            >
              Reject
            </v-btn>
            <v-btn
              :disabled="!formValid"
              color="primary"
              @click="approveAction"
              :loading="loading"
            >
              Approve
            </v-btn>
          </div>
        </v-row>
      </div>
    </v-card>

    <v-dialog v-model="showProgressBar" persistent max-width="500">
      <div style="width: 100%; height: 10px; background-color: #146b76"></div> 
      <v-card class="d-flex flex-column align-center pa-4">
        <v-card-title class="text-h6 text-center">{{ progressTitle }}</v-card-title>

        <v-card-text class="d-flex flex-column align-center pa-4">
          <v-progress-linear :value="percentage" :color="progressColor" height="15" class="mb-3 rounded-xl " style="width: 100%"/>
          <div class="text-center">
            <strong>{{ Math.ceil(percentage) }}%</strong>
          </div>

          <v-row class="justify-center mt-10" style="width: 100%">
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" @click="closeProgressBar" :disabled="disabledProgress">OK</v-btn>
            </v-col>
            <v-col cols="6" class="d-flex justify-center">
              <v-btn min-width="100%" color="primary" @click="goToHistory" :disabled="disabledProgress">Go to History Request</v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { date, showAlert } from '../../lib/helpers';

export default {
  data() {
    return {
      remark: '',
      confirmationChecked: false,
      remarksError: '',
      formValid: false,
      confirmationText: `Saya telah memeriksa ulang pengajuan dan saya telah membaca, memahami, dan menyetujui seluruh syarat dan ketentuan yang berlaku terkait dengan proses insert transaction off us.  Saya juga memahami bahwa dengan memberikan konfirmasi ini,
      saya mengizinkan untuk memproses insert transaction off us atas transaksi tersebut sesuai dengan prosedur yang telah ditetapkan.
      Saya bertanggung jawab penuh atas kebenaran data yang saya setujui dan konsekuensi dari setiap kesalahan data tersebut. Saya juga memahami bahwa konfirmasi ini tidak dapat dibatalkan ketika approval transaction off us dilakukan.*`
    };
  },
  computed : {
    disabledProgress() {
      if (this.percentage < 100 && this.failedResponse === false) {
        return true;
      }

      return false;
    },
    data() {
      return this.$store.state.approvalInsertTransactionOnUs.dataDetail;
    },

    loading() {
      return this.$store.state.approvalInsertTransactionOnUs.loading;
    },
    showProgressBar() {
      return this.$store.state.approvalInsertTransactionOnUs.showProgressBar;
    },
    percentage() {
      return this.$store.state.approvalInsertTransactionOnUs.percentage;
    },
    progressTitle() {
      return this.$store.state.approvalInsertTransactionOnUs.progressTitle;
    },
    progressColor() {
      return this.$store.state.approvalInsertTransactionOnUs.progressColor;
    },
    failedResponse() {
      return this.$store.state.approvalInsertTransactionOnUs.isFailedResponse;
    },
    statusApprove() {
      return this.$store.state.approvalInsertTransactionOnUs.approvedStatus;
    },
  },

  methods: {
    async getDetail() {
      this.loading = true;
      await this.$store.dispatch('approvalInsertTransactionOnUs/getDetail',  { date, id: this.$route.params.id });
      this.loading = false;
    },
    async rejectAction() {
      
      try {
        const res = await this.$store.dispatch('approvalInsertTransactionOnUs/rejectInsert', {
          date,
          id: [this.$route.params.id || this.data().id],
          remark: this.remark,
        });

        if (res !== false) {
          this.$router.push('/insert-transaction-on-us/approval-insert-transaction');
        } 
      } catch (error) {
        showAlert(this.$store, 'Something Went Wrong !', 'mdi-alert', 'red');
      }
    },
    async approveAction() {

      try {
        await this.$store.dispatch('approvalInsertTransactionOnUs/approveInsert', {
          date,
          id: [this.$route.params.id || this.data().id],
          options: this.options,
          remark: this.remark,
        });

      } catch (error) {
        showAlert(this.$store, 'Something Went Wrong !', 'mdi-alert', 'red');
      }
    },

    validateRemarks() {
      if (!this.remark) {
        this.remarksError = 'Remarks required !';
      } else {
        this.remarksError = '';
      }
      this.validateForm();
    },
    validateForm() {
      this.formValid = this.remark !== '' && this.confirmationChecked;
    },
    goBack() {
      this.$router.push('/insert-transaction-on-us/approval-insert-transaction');
    },
    goToHistory() {
      this.$router.push('/insert-transaction-on-us/history-insert-transaction');
    },
    async closeProgressBar() {
      if (this.statusApprove?.payload === "success") {
        await this.$store.dispatch('approvalInsertTransactionOnUs/closeProgressBar');
        this.$router.push('/insert-transaction-on-us/approval-insert-transaction').catch((error) => {
          if (error.name !== 'NavigationDuplicated') {
            console.error(error);
          }
        });
      }
    },
  },
  mounted() {
    this.getDetail();
  },
};
</script>

<style>
.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}
</style>